module.exports = __webpack_public_path__ + "img/31_12.b7066009.png";